<template>
  <div class="sub-page withdraw-list">
    <div class="list-option-nav">
      <div>
        <h2>酒桶管理</h2>
      </div>

      <div class="">
        <b-button class="mr-3" @click="exportExcel">酒桶現狀匯出</b-button>
        <b-button class="mr-3" @click="exportLogExcel">Log匯出</b-button>
        <b-button class="mr-3" @click="clientBatchSyncModalShow = true">更新客戶資料</b-button>

        <b-button class="mr-3" @click="kegMiniDashboardModalShow = true">在庫酒桶現狀</b-button>
        <b-button variant="primary" @click="kegCreateSelectModalShow = true">新增酒桶</b-button>
      </div>
    </div>

    <div class="list-option-nav">
      <div class="col-auto">
        <div class="row">
          <div class="col-auto">
            <b-button variant="primary" @click="refreshData">
              <b-icon icon="arrow-repeat" class="m-0"></b-icon>
            </b-button>
          </div>
          <div class="col-auto">
            <b-button @click="kegListFilteringModalShow = true">
              <b-icon icon="funnel"></b-icon>篩選
            </b-button>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <div class="row align-items-center">
          <div class="col-auto">
            <span>共 {{ filteredData.length }} 筆資料</span>
          </div>
          <div class="col-auto">
            <b-form-input type="search" placeholder="輸入酒桶ID進行搜尋" v-model="inputSearchKid"></b-form-input>
          </div>
          <div class="col-auto">
            <div class="table-per-page-option desc-color d-flex align-items-center">
              <span>顯示</span>
              <b-form-select v-model="perPage">
                <b-form-select-option
                    v-for="option in tablePerPageOptions"
                    :key="option.value"
                    :value="option.value"
                >
                  {{ option.value }}
                </b-form-select-option>
              </b-form-select>
              <span>筆/頁</span>
            </div>
          </div>
        </div>
      </div>
      

    </div>
    <div class="table-items">
      <b-table
        thead-class="sticky-thead"
        tbody-tr-class="align-center"
        :items="sortedData"
        select-mode="multi"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :fields="tablefields"
        :per-page="perPage"
        :current-page="currentPage"
        selectable
        ref="selectableTable"
        @row-selected="onRowSelected"

      >

        <template #cell(selected)="data">
          <b-form-checkbox class="row-selected" v-model="data.rowSelected" @change="toggleRowSelection(data)">
          </b-form-checkbox>
        </template>

        <template #cell(kid)="data">
          <p class="mb-0">{{data.item.kid}}</p>
        </template>

        <template #cell(sizeModel)="data">
          <p class="mb-0">{{data.item.sizeModel}}</p>
        </template>

        <template #cell(status)="data">
          <p class="mb-0">
            <b-badge pill :variant="`status-${data.item.status}`">{{ statusString(data.item.status)}}</b-badge>
          </p>
        </template>

        <template #cell(lastRentTimestamp)="data">
          <p class="mb-0" v-if="data.item.status !== 1 && data.item.status !== 0">-</p>
          <p class="mb-0" v-else>
            <span class="pr-3" :class="{'text-danger': isOutOfDelayLimit(data.item)}">{{ formatDate(data.item.lastRentTimestamp) }} ~</span>
            <b-badge :variant="`delay-${isOutOfDelayLimit(data.item)?'true':'false'}`">{{ dayUntilToday(data.item.lastRentTimestamp) }}天</b-badge>
          </p>
        </template>

        <template #cell(cname)="data">
          <p class="mb-0" v-if="data.item.status !== 1"> - </p>
          <p class="mb-0" v-else>{{data.item.cname}}</p>
        </template>

        <template #cell(salesman)="data">
          <p class="mb-0" v-if="data.item.status !== 1"> - </p>
          <p class="mb-0" v-else>{{data.item.salesman}}</p>
        </template>

        <template #cell(washed)="data">
          <div>
            <b-badge pill :variant="`washed-${data.item.washed?'true':'false'}`">{{ data.item.washed?'已清洗':'未清洗' }}</b-badge>
          </div>
        </template>

        <template #cell(filled)="data">
          <div>
            <b-badge pill :variant="`filled-${data.item.filled?'true':'false'}`">{{ data.item.filled?'已填充':'未填充' }}</b-badge>
          </div>
        </template>

        <template #cell(action)="data">
          <p class="mb-0">
            <a href="#" @click.prevent="infoClicked(data.item.serial)">
              <b-icon icon="pencil-square"></b-icon>
            </a>
          </p>
        </template>


        
      </b-table>
      <div class="w-100 d-flex justify-content-center">
        <b-pagination
            v-if="totalRows >= perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
        >
          <template #first-text>
            <Icon name="Expand_left_double_light" size="24" />
          </template>
          <template #prev-text>
            <Icon name="Expand_left_light" size="24" />
          </template>
          <template #next-text>
            <Icon name="Expand_right_light" size="24" />
          </template>
          <template #last-text>
            <Icon name="Expand_right_double_light" size="24" />
          </template>
        </b-pagination>
      </div>
    </div>

    <KegCreateSelectModal v-model="kegCreateSelectModalShow" @selected="createMethodSelected"></KegCreateSelectModal>
    <KegCreateSingleModal v-model="kegCreateSingleModalShow"></KegCreateSingleModal>
    <KegInfoModal v-model="kegInfoModalShow" :keg="focusData" editable></KegInfoModal>
    <KegCreateBatchModal v-model="kegCreateBatchModalShow"></KegCreateBatchModal>
    <KegListFilteringModal v-model="kegListFilteringModalShow" :filter="filter" @update="filterUpdated"></KegListFilteringModal>
    <ClientBatchSyncModal v-model="clientBatchSyncModalShow"></ClientBatchSyncModal>
    <KegMiniDashboardModal v-model="kegMiniDashboardModalShow"></KegMiniDashboardModal>
    <KegLogExportModal v-model="kegLogExportModalShow"></KegLogExportModal>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import moment from 'moment';
import KegCreateSelectModal from "./modals/KegCreateSelectModal.vue";
import KegCreateSingleModal from "./modals/KegCreateSingleModal.vue";
import KegInfoModal from "./modals/KegInfoModal.vue";
import KegCreateBatchModal from "./modals/KegCreateBatchModal.vue";
import KegListFilteringModal from "./modals/KegListFilteringModal.vue";
import ClientBatchSyncModal from "./modals/ClientBatchSyncModal.vue";
import ExportJsonExcel from "js-export-excel";
import KegMiniDashboardModal from "./modals/KegMiniDashboardModal.vue";
import KegLogExportModal from "./modals/KegLogExportModal.vue";

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegList',
  data() {
    return {
      SAVE_INFO_BUSY: 'KegListSave',

      sortBy: 'lastRentTimestamp',
      sortDesc: false,

      delayLimit: 30,

      filter: {
        filterStatus: [],
        filterWashed: [],
        filterFilled: [],
        filterSize: [],
      },
      inputSearchKid: '',

      tablePerPageOptions: [
        { value: 5 },
        { value: 10 },
        { value: 15 },
        { value: 20 },
      ],
      tablefields: [
        { key: 'selected', label: '' },
        { key: 'kid', label: 'ID', sortable: true },
        { key: 'sizeModel', label: '尺寸', sortable: true },
        { key: 'status', label: '借用狀態', sortable: true },
        { key: 'lastRentTimestamp', label: '狀態累計天數', sortable: true },
        { key: 'cname', label: '客戶名稱' },
        { key: 'salesman', label: '負責業務' },
        { key: 'washed', label: '清洗進度', sortable: true },
        { key: 'filled', label: '填充進度', sortable: true },
        { key: 'action', label: '' },
      ],
      selectedData: [],
      currentPage: 1,
      perPage: 10,

      focusDataSerial: -1,

      kegCreateSelectModalShow: false,
      kegCreateSingleModalShow: false,
      kegInfoModalShow: false,
      kegCreateBatchModalShow: false,
      kegListFilteringModalShow: false,
      clientBatchSyncModalShow: false,
      kegMiniDashboardModalShow: false,
      kegLogExportModalShow: false,
    };
  },
  props: {
  },
  components: {
    KegCreateSelectModal,
    KegCreateSingleModal,
    KegInfoModal,
    KegCreateBatchModal,
    KegListFilteringModal,
    ClientBatchSyncModal,
    KegMiniDashboardModal,
    KegLogExportModal,
  },
  computed: {
    ...mapState('keg', ['kegList']),
    ...mapState('client', ['clientList']),

    focusData() {
      const d = this.combinedData.find((item) => {
        return item.serial === this.focusDataSerial;
      });
      if (d) {
        return d;
      } else {
        return {};
      }
    },
    combinedData() {
      const list = [ ... this.kegList];
      for (let i=0;i<list.length;i++) {
        list[i].lastRentTimestamp = list[i].lastStatusChangeTime;
      }
      return list;
    },
    filteredData() {
      const list = [ ... this.combinedData];
      const filtered = list.filter((item) => {
        if (this.inputSearchKid.trim().length > 0) {
          if (item.kid.indexOf(this.inputSearchKid.trim()) === -1) {
            return false;
          }
        }
        if (this.filter.filterStatus.length > 0) {
          if (this.filter.filterStatus.indexOf(item.status) === -1) {
            return false;
          }
        }

        if (this.filter.filterWashed.length > 0) {
          if (this.filter.filterWashed.indexOf(item.washed) === -1) {
            return false;
          }
        }

        if (this.filter.filterFilled.length > 0) {
          if (this.filter.filterFilled.indexOf(item.filled) === -1) {
            return false;
          }
        }

        if (this.filter.filterSize.length > 0) {
          if (this.filter.filterSize.indexOf(item.sizeModel) === -1) {
            return false;
          }
        }

        return true;
      });
      return filtered;
      // return this.withdrawListData.filter((w) => {
      //   return !this.showWaitingOnly || (w.status === 0);
      // }).map((w) => {
      //   return {
      //     ...w,
      //   };
      // });
    },
    sortedData() {
      const copy = [... this.filteredData];
      copy.sort((a, b) => {
        return new Date(b.create_at).getTime() - new Date(a.create_at).getTime();
      });
      return copy;
    },
    totalRows() {
      return this.filteredData.length;
    },
    totalSelectedRows() {
      return this.selectedData.length;
    },
    
  },
  watch: {
  },
  async mounted() {
    await this.handleAsyncTask(this.refreshKegList);
    await this.handleAsyncTask(this.initClientList);
  },
  methods: {
    ...mapActions('keg', ['refreshKegList', 'initKegList']),
    ...mapActions('client', ['refreshClientList', 'initClientList']),
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),

    async refreshData() {
      await this.handleAsyncTask(this.refreshKegList);
      await this.handleAsyncTask(this.refreshClientList);
    },
    toggleRowSelection(data) {
      if(data.rowSelected) {
        this.$refs.selectableTable.selectRow(data.index)
      } else {
        this.$refs.selectableTable.unselectRow(data.index)
      }
    },
    formatDate(t) {
      return moment(t).format('YYYY/MM/DD');
    },
    dayUntilToday(t) {
      return parseInt(moment.duration(moment().diff(moment(t))).asDays());
    },
    onRowSelected(items) {
      this.selectedData.splice(0);
      items.map(d => {
        this.selectedData.push(d);
      });
    },
    createMethodSelected(action) {
      this.kegCreateSelectModalShow = false;
      if (action === 'single') {
        this.kegCreateSingleModalShow = true;
      } else if (action === 'batch') {
        this.kegCreateBatchModalShow = true;
      }
    },
    infoClicked(serial) {
      this.focusDataSerial = serial;
      this.kegInfoModalShow = true;
    },
    statusString(index) {
      const ary = ['在庫', '出借', '失蹤', '退役'];
      return ary[index];
    },
    filterUpdated(filter) {
      this.filter.filterStatus.splice(0);
      this.filter.filterWashed.splice(0);
      this.filter.filterFilled.splice(0);
      this.filter.filterSize.splice(0);

      for (const s of filter.filterStatus) {
        this.filter.filterStatus.push(s);
      }
      for (const s of filter.filterWashed) {
        this.filter.filterWashed.push(s);
      }
      for (const s of filter.filterFilled) {
        this.filter.filterFilled.push(s);
      }
      for (const s of filter.filterSize) {
        this.filter.filterSize.push(s);
      }
      this.currentPage = 1;
    },
    exportExcel() {
      const data = this.filteredData.map((item) => {
        return {
          kid: item.kid,
          status: this.statusString(item.status),
          lastStatusChangeTime: moment(item.lastStatusChangeTime).format('YYYY-MM-DD HH:mm:ss'),
          sizeModel: item.sizeModel,
          rentClient: item.cname || '',
          salesman: item.salesman || '',
          washed: item.washed? 'V': '',
          lastWashedTime: moment(item.lastWashedTime).format('YYYY-MM-DD HH:mm:ss'),
          filled: item.filled? 'V': '',
          lastFilledTime: moment(item.lastFilledTime).format('YYYY-MM-DD HH:mm:ss'),
          isReused: item.isReused? 'V': ''
        };
      })
      const option = {
        fileName: '酒桶資訊',
        datas: [
          {
            sheetData: data,
            sheetName: "酒桶資訊",
            sheetHeader: 'ID,狀態,最新狀態變更時間,尺寸,出借客戶,出借客戶業務,是否已清洗,上次清洗時間,是否已填充,上次填充時間,是否為再利用酒桶'.split(','),
          },
        ]
      };
      const toExcel = new ExportJsonExcel(option); //new
      toExcel.saveExcel(); //保存
    },
    async exportLogExcel() {
      this.kegLogExportModalShow = true;
      // await this.$store.dispatch('api/getKegLogExcelPromise');
    },
    clientNameString(serial) {
      const c = this.clientList.find((item) => {
        return item.serial === serial;
      });
      return c?c.name: '';
    },
    clientSalesmanString(serial) {
      const c = this.clientList.find((item) => {
        return item.serial === serial;
      });
      return c?c.salesman: '';
    },
    isOutOfDelayLimit(keg) {
      const days = this.dayUntilToday(keg.lastRentTimestamp);
      return days > this.delayLimit;
    },
  },
}
</script>

<style lang="scss">
@import "src/assets/scss/basic";
.withdraw-list {
  .list-option-nav {
    top: 0px;
    z-index: 3;
    background-color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2.5rem 5rem 1rem;
    button:not(:last-child) {
      margin-right: 1.25rem;
    }
    .table-per-page-option {
      margin-left: .5rem;
      .custom-select {
        width: 80px;
        height: 51px;
        padding: .75rem 1.5rem;
        margin-left: 1rem;
        margin-right: .5rem;
      }
    }
  }
  .table-items {
    background: $color-white;
    padding: 0 3rem 1rem;
    thead.sticky-thead {
      // position: sticky;
      // top: calc(0px + 107px);
      // z-index: 100;
      // background: $color-white;
      // box-shadow: inset 0 -1px $color-border;
      // padding-top: 1rem;
    }

    .cloth-list-img {
      width: 6rem;
      height: 6rem;
      object-fit: contain;
    }

    .detail-btn {
      color: #404040;
      display: block;
      padding-top: .1rem;
      >span {
        display: inline-block;
        padding-right: .5rem;
      }
      >svg {
        display: inline-block;
        vertical-align: baseline;
      }
    }
    .row-solved {
      background-color: $color-gray-light;
    }
    .table.b-table > tbody > .table-active, .table.b-table > tbody > .table-active > th, .table.b-table > tbody > .table-active > td {
      background-color: $color-yellow-light;
    }
    .row-selected {
      padding-left: 20px;
      &.custom-control.custom-checkbox .custom-control-label::before, &.custom-control.custom-checkbox .custom-control-label::after {
        top: 2px;
        left: -8px;
      }
    }

    a {
      color: $color-primary;
    }

    .badge{
      &.badge-status-0 {
        border: solid 1px $color-background-deep-yellow;
        background-color: $color-background-deep-yellow;
        color: $color-tertiary;
      }
      &.badge-status-1 {
        border: solid 1px $color-tertiary;
        background-color: transparent;
        color: $color-tertiary;
      }

      &.badge-status-2 {
        border: solid 1px $color-danger;
        background-color: transparent;
        color: $color-danger;
      }

      &.badge-status-3 {
        border: solid 1px $color-background-deep-yellow;
        background-color: transparent;
        color: $color-background-deep-yellow;
      }


      &.badge-washed-false {
        border: solid 1px $color-tertiary;
        background-color: transparent;
        color: $color-tertiary;
      }

      &.badge-washed-true {
        border: solid 1px $color-background-deep-yellow;
        background-color: $color-background-deep-yellow;
        color: $color-tertiary;
      }

      
      &.badge-filled-false {
        border: solid 1px $color-tertiary;
        background-color: transparent;
        color: $color-tertiary;
      }

      &.badge-filled-true {
        border: solid 1px $color-tertiary;
        background-color: $color-tertiary;
        color: #fff;
      }



      &.badge-delay-true {
        border: solid 1px $color-danger;
        background-color: transparent;
        color: $color-danger;
      }

      &.badge-delay-false {
        border: solid 1px $color-black-300;
        background-color: transparent;
        color: $color-primary;
      }
    }
  }
  .desc-color {
    color: $typography-secondary-default;
  }
}
</style>
